import Vue from "vue";
import Vuex from "vuex";
import website from "./modules/website.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    website
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js